import classNames from 'classnames'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import type { ReactElement } from 'react'

interface Props {
  alt?: string
  className?: string
  height?: number
  src: string
  width?: number
}

const LazyLoadedImage = ({ alt, className, height = 100, src, width = 100 }: Props): ReactElement => {
  return (
    <LazyLoadImage
      alt={alt}
      className={classNames('lazy-loaded-image-component', className)}
      effect="opacity"
      height={height}
      src={src}
      width={width}
    />
  )
}

export default LazyLoadedImage
